export default __webpack_public_path__ + "static/media/bg-desktop1.9371c3d4.svg";